import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {
  ServiceCatalogActions,
  ServiceCatalogActionTypes,
} from '../_actions/service-catalog.actions';
import { ServiceCatalogModel } from '../_models/service-catalog.model';
import { QueryParamsModel } from '../../_base/crud';

export interface ServiceCatalogsState extends EntityState<ServiceCatalogModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedServiceCatalogId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
  latestSuccessfullAction: any;
}

export const adapter: EntityAdapter<ServiceCatalogModel> =
  createEntityAdapter<ServiceCatalogModel>();

export const initialServiceCatalogsState: ServiceCatalogsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastCreatedServiceCatalogId: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
  latestSuccessfullAction: null,
});

export function serviceCatalogsReducer(
  state = initialServiceCatalogsState,
  action: ServiceCatalogActions,
): ServiceCatalogsState {
  switch (action.type) {
    case ServiceCatalogActionTypes.ServiceCatalogsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedServiceCatalogId: undefined,
      };
    case ServiceCatalogActionTypes.ServiceCatalogActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case ServiceCatalogActionTypes.ServiceCatalogCreated:
      return adapter.addOne(action.payload.serviceCatalog, {
        ...state,
        lastCreatedServiceCatalogId: action.payload.serviceCatalog.id,
      });
    case ServiceCatalogActionTypes.ServiceCatalogUpdated:
      return adapter.updateOne(action.payload.partialServiceCatalog, state);
    case ServiceCatalogActionTypes.OneServiceCatalogDeleted:
      return adapter.removeOne(action.payload.id, state);
    case ServiceCatalogActionTypes.ServiceCatalogsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
        showInitWaitingMessage: false,
      };
    case ServiceCatalogActionTypes.ServiceCatalogsPageLoaded:
      return adapter.addMany(action.payload.serviceCatalogs, {
        ...initialServiceCatalogsState,
        totalCount: action.payload.totalCount,
        listLoading: false,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    case ServiceCatalogActionTypes.ThrowServiceCatalogError:
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    case ServiceCatalogActionTypes.FireServiceCatalogSuccess:
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    default:
      return state;
  }
}

export const getServiceCatalogState =
  createFeatureSelector<ServiceCatalogsState>('serviceCatalogs');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
